import React from 'react';
import './CheckoutHeader.scss';

const CheckoutHeader = props => {
    const {cartHeader} = props;
    const dealsKart = cartHeader.indexOf('dealskart') > -1 || false;
    const imgStyle = {
        height: dealsKart ? '22px' : '34px'
    };
    return (
        <div className="checkout-header col-lg-12 col-md-12 col-sm-12">
            {cartHeader && <span className="logo">
                <img src={cartHeader} alt="logo" style={imgStyle} /></span>}
            {/* <span className="support-link">support@lenskart.com</span> */}
            {!cartHeader && <a className="logo">
            <img src="" alt="" /></a>}
        </div>
    );
};

export default CheckoutHeader;
